import React, {useEffect, useState} from 'react';
import {Col, Modal, Row} from "react-bootstrap";
import {word} from "../../word.js";
import {Autocomplete, TextField} from "@mui/material";
import Loader from "../BlueButton/Loader.js";
import CheckboxFilter from "../CheckboxFilter.js";
import BlueButton from "../BlueButton/BlueButton.js";
import {toast} from "react-toastify";
import {useDispatch, useSelector} from "react-redux";
import {REACT_APP_API_URL} from "../../config.js";
import {accountantRequest, taskCompanyRequest} from "../../store/actions/task.js";
import TextAreaTask from "./TextAreaTask.js";
import Api from "../../Api.js";
import SuccessToast from "../BlueButton/SuccessToast.js";
import ErrorToast from "../BlueButton/ErrorToast.js";
import {useNavigate} from "react-router-dom";

function ChangeRecommendation({onHide, show,copy,task}) {
    const login = useSelector((state) => state.manager.employee);
    const account = useSelector((state) => state.task.accountant);
    const companies = useSelector((state) => state.task.companies);
    const [limitData, setLimitData] = useState({
        organization: [],
        stuff: [],
    });
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [images, setImages] = useState([]);
    const managers = useSelector((state) => state.task.managers);

    function getValue(data, key) {
        return key.split(".").reduce((obj, keyPart) => obj?.[keyPart], data) || null;
    }
    useEffect(() => {
        (async () => {
            setLimitData({
                organization: companies.map(s => ({...s,url:REACT_APP_API_URL+'manager-company/'+s.id+'/'})),
                stuff: account.map(s => ({...s,url:REACT_APP_API_URL+'accountant/'+s.id+'/'})),
                manager: managers,
            })
        })()
    }, [account,companies,managers])
    const [visibleForClient, setVisibleForClient] = useState(task ? task.visible_for_client : "");
    const [form, setForm] = useState([
        {
            key: "name",
            value: task ? task.name : "",
            errorMessage: "empty_error",
            type: "textarea",
            label: "",
            valid: true,
        },
        {
            key: "text",
            value: task ?  task.text  : "",
            errorMessage: "empty_error",
            type: "textarea",
            label: "",
            valid: true,
        },
        {
            key: "company",
            value: task ? task.company : "",
            option: "organization",
            errorMessage: "select_error",
            type: "dropDown",
            label: task ? task.company_name : "",
            valid: true,
        },
        {
            key: localStorage.getItem("profession") !== "manager" ? "accountant" : "manager",
            value: task ? getValue(task, localStorage.getItem("profession") !== "manager" ? "accountant" : "manager") || '' : "",
            option: localStorage.getItem("profession") !== "manager" ? "stuff" : "manager",
            errorMessage: "select_error",
            type: "dropDown",
            label: task ? localStorage.getItem("profession") === "manager"? task.manager_name : `${task.accountant_first_name} ${task.accountant_last_name}` : "",
            valid: true,
        },
    ]);

    const submit = async () => {
        const formData = new FormData();
        setSubmitted(true);
        setDisabled(true);
        setLoading(true);

        images.forEach((image, index) => {
            formData.append(`file${index + 1}`, image, image.name);
        });

        form.forEach((field) => {
            if (!field.valid) {
                setDisabled(false);
                setLoading(false);
                return;
            }
            formData.append(field.key, field.value);
        });

        formData.append("template_id", task?.template_id || 0);
        formData.append("visible_for_client", visibleForClient);

        try {
            if (copy) {
                formData.append("creator", login.user.url);
                const res = await Api.createTask(formData);
            } else {
                const res = await Api.editTask(formData, task.id);
            }
            SuccessToast();
            setDisabled(false);
            setLoading(false);
            onHide();
            navigate(-1)
        } catch (error) {
            ErrorToast()
        }
    };
    const keyPress = async (e) => {
        if (e.key === "Enter") {
            await submit();
        }
    };
    useEffect(() => {
        (async () => {
            await dispatch(accountantRequest())
            await dispatch(taskCompanyRequest())
        })();
    }, []);
    const renderDropDown = (item, index) => {
        const options = (limitData[item.option] || []).filter((el) =>
            item.option !== "organization" ? el?.user?.is_active : !el?.is_deleted_by_manager
        );

        return (
            <div key={index} className={!item.valid && submitted ? "input-validation input-validation-valid" : "input-validation"}>
                <Autocomplete
                    defaultValue={form[index]}
                    options={options}
                    loading={options.length === 0}
                    loadingText={<div className="auto-complete-loader"><Loader type="Oval" color="#101C2A" height={20} width={20} /></div>}
                    onChange={(e, value) => {
                        console.log(value)
                        setForm((prevForm) => {
                            const updatedForm = [...prevForm];
                            updatedForm[index].value = value ? value.url : "";
                            updatedForm[index].valid = !!(value ? value.url : "");
                            return updatedForm;
                        });
                    }}
                    getOptionKey={(option) => option.id}
                    getOptionLabel={(option) => {
                        if (option.user && option.user.first_name && option.user.last_name) {
                            return `${option.user.first_name} ${option.user.last_name}`;
                        }
                        if (option.name) {
                            return option.name;
                        }
                        return option.label
                    }}
                    renderInput={(params) => {
                        return(
                            <TextField
                                {...params}
                                value={item.label}
                                error={!item.valid && submitted}
                                label={word[item.key]}
                                onKeyDown={keyPress}
                                variant="outlined"
                            />
                        )
                    }}
                />
                {!item.valid && submitted && <div className="validation valid-center">{word[item.errorMessage]}</div>}
            </div>
        );
    };
    const handleFileChange = (e) => {
        let file = e.target.files[0];
        if (!file) return;

        let reader = new FileReader();
        reader.onloadend = () => {
            setImages((prevImages) => [...prevImages, file]);
        };
        reader.readAsDataURL(file);
    };
    const handleDeletePhoto = (item) => {
        setImages((prevImages) => prevImages.filter((el) => el.name !== item.name));
    };
    return (
        <Modal
            {...{onHide, show}}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered


        >
            <Modal.Header className='green-top'>
                <Modal.Title id="contained-modal-title-vcenter"
                             className="w-100 d-flex flex-row justify-content-between">
                    <span>{copy ? word.new_recommendations : word.edit_task}</span>
                    <div className="tool-tip-cont">
                        <div className="tool-tip">Փակել</div>
                        <i className="fas fa-times" onClick={onHide}/>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='container'>
                    <Row className="justify-content-center">
                        <Col xs={12} sm={10}>
                            {form.map((item, index) => {
                                if (item.type === "textarea") {
                                    return <TextAreaTask item={item} index={index} setFormData={setForm} submitted={submitted}/>;
                                }
                                if (item.type === "dropDown") {
                                    return renderDropDown(item, index);
                                }
                                return null;
                            })}

                            <CheckboxFilter
                                title="Տեսանելի բոլորի համար"
                                my_task={visibleForClient}
                                onChange={() => setVisibleForClient(!visibleForClient)}
                            />

                            <div className='img-icon-cont'>
                                <div className='img-cont'>
                                    {images.map((item, index) =>
                                        index < 4 ? (
                                            <div className='img' key={index}>
                                                <span className={(item.type === "image/jpeg" || item.type === "image/png") ? 'icon-Photos' : "icon-files-empty"} />
                                                <span className='images-name'>{item.name}</span>
                                                <i className="fas fa-times" onClick={() => handleDeletePhoto(item)}/>
                                            </div>
                                        ) : "..."
                                    )}
                                </div>

                                <label>
                                    <span className='icon-Attachment'/>
                                    <input type="file" className='input-icon' onChange={handleFileChange} />
                                </label>
                            </div>

                            <div className='line-blue'/>

                            {loading && (
                                <div className="disable-loader">
                                    <Loader type="Oval" color="#101C2A" height={30} width={30} />
                                </div>
                            )}

                            <div className='button-line'>
                                <BlueButton
                                    disabled={disabled}
                                    title={copy ? word.create : word.edit}
                                    buttonStyle={!disabled ? "blue-button" : "blue-button blue-button-disabled"}
                                    onChangeValue={submit}
                                />
                            </div>
                        </Col>
                    </Row>
                </div>

            </Modal.Body>
        </Modal>
    );
}

export default ChangeRecommendation;